import styled from 'styled-components'

const ActionBox = styled.div`
  margin: 32px 0 0;
  text-align: center;
`

const IconImage = styled.img`
  display: block;
  width: 250px;
  margin: auto;
  margin-bottom: 24px;
`

const ErrorRoot = styled.div`
  padding: 48px 32px;
  width: 100%;

  > p,
  > h2 {
    text-align: center;
    font-weight: 400;
  }

  > p {
    color: rgba(0, 0, 0, 0.54);
    max-width: 500px;
    margin: auto;
  }

  > h6 {
    line-height: 1.8;
  }
`

export { ErrorRoot, ActionBox, IconImage }
